import React from 'react';

import { FilterSelect } from '@/components/shared/FilterSelect/FilterSelect';
import { ContentStatus, ExploreBlockType } from '@addmile/backend-client';

import { BLOCK_TYPES, CONTENT_STATUS, SUPPORTED_LANGUAGES } from '../../const';

export type GetBlockParams = {
  cursor?: number;
  title?: string;
  type?: ExploreBlockType[];
  language?: string;
  status?: ContentStatus[];
  pageSize?: number;
};

interface BlockFiltersProps {
  filters: GetBlockParams;
  onFilterChange: (key: keyof GetBlockParams, value: GetBlockParams[keyof GetBlockParams]) => void;
}

export const BlockFilters: React.FC<BlockFiltersProps> = ({ filters, onFilterChange }) => {
  return (
    <div className="gap-4 bg-gray-50 rounded-lg mb-4">
      <input
        className="px-3 py-3 border border-neutral-20 rounded-lg text-sm w-full max-w-[551px]"
        type="text"
        value={filters.title || ''}
        onChange={(e) => onFilterChange('title', e.target.value || undefined)}
        placeholder="Search by title..."
      />

      <div className="flex gap-4 mt-3">
        <FilterSelect
          label="Type"
          value={filters.type && filters.type.length > 0 ? filters.type[0] : ''}
          onChange={(value) =>
            onFilterChange('type', value ? ([value] as ExploreBlockType[]) : undefined)
          }
          options={[
            { value: '', label: 'All Types' },
            ...BLOCK_TYPES.map(({ value, label, icon }) => ({ value, label, icon })),
          ]}
        />

        <FilterSelect
          label="Language"
          value={filters.language || ''}
          onChange={(value) => onFilterChange('language', value || undefined)}
          options={[
            { value: '', label: 'All Languages' },
            ...SUPPORTED_LANGUAGES.map(({ value, label, icon }) => ({ value, label, icon })),
          ]}
        />

        <FilterSelect
          label="Status"
          value={filters.status && filters.status.length > 0 ? filters.status[0] : ''}
          onChange={(value) =>
            onFilterChange('status', value ? ([value] as ContentStatus[]) : undefined)
          }
          options={[
            { value: '', label: 'All Statuses' },
            ...CONTENT_STATUS.map(({ value, label, icon, color }) => ({
              value,
              label,
              icon,
              color,
            })),
          ]}
        />
      </div>
    </div>
  );
};

export default BlockFilters;
